module.exports = __webpack_public_path__ + "static/media/YeChiBao.8a282c57.jpg";